export class RecoveryPlan {
  additionalInformation?: { additionalInfo: string, type: number }[] = [];
  brandId: string = "";
  completedDate: string = "";
  createdOn: number = 0;
  customerName: string = "";
  dealerId: string = "";
  description: string = "";
  dtCancel: number = 0;
  dtClose: number = 0;
  dtEnd: number = 0;
  dtInsert: number = 0;
  dtStart: number = 0;
  dtApproved: number = 0;
  firstName: string = "";
  lastName: string = "";
  marketId: string = "";
  note: string = "";
  outletId: string = "";
  outletName: string = "";
  dealerName: string = "";
  recoveryPlanId: string = "";
  regionId: string = "";
  sectionValue: string = "";
  status: string = "";
  surveyRequestId: string = "";
  title: string = "";
  user: string = "";
  usrCancel: string = "";
  usrClose: string = "";
  usrInsert: string = "";
  vin: string = "";
  wave: string = "";
  dateCancel: Date | string;
  dateClose: Date | string;
  dateEnd: Date | string;
  dateInsert: Date | string;
  dateStart: Date | string;
  closeAction = "";
  editAction = "";
  infoAction = "";
  deleteAction = "";
  _id: string = "";
  disabled: boolean;
  checked: boolean;
  assignTo?: string;
  brand:string;
  region:string;
  dataSurvey:string;
  attach?: boolean = false;
  fullName: string = "";
  hotAlertClosingTime: string = ''
  contactReasonL1: string = "";
  contactReasonL2: string = "";
  dissatisfacionReason1Level1: string = "";
  dissatisfacionReason1Level2: string = "";
  dissatisfacionReason2Level1: string = "";
  dissatisfacionReason2Level2: string = "";
  personEnteringInfo: string = "";
  constructor(plan: any) {
    Object.assign(this, plan);
    this.dateCancel = this.parseDate(this.dtCancel);
    this.dateClose = this.parseDate(this.dtClose);
    this.dateEnd = this.parseDate(this.dtEnd);
    this.dateInsert = this.parseDate(this.dtInsert);
    this.dateStart = this.parseDate(this.dtStart);
    this._id = this.recoveryPlanId;
    this.disabled = this.status === "Closed";
    this.checked = this.status === "Closed";
    this.brand = this.brandId;
    this.region = this.regionId;
    this.dataSurvey = this.completedDate;
    this.fullName = this.firstName ? this.firstName : '' + ' ' + this.lastName ?  this.lastName : ''
  }

  private parseDate(timestamp: number | string) {
    if (timestamp && timestamp !== "not valid" && timestamp !== "valid") {
      let date = new Date(timestamp);
      return date;
    } else {
      return "";
    }
  }
}
